module.exports = __webpack_public_path__ + "components/country-flag/static/sz-750ccf20a2565b5d4fe0f03d004024d0.svg";